import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  cs: {
    // Navigation
    nav: {
      home: 'Úvod',
      about: 'O firmě',
      services: 'Služby',
      technology: 'Technologie',
      machinery: 'Strojový park',
      references: 'Reference',
      career: 'Kariéra',
      contact: 'Kontakt'
    },
    // Hero Section
    hero: {
      subtitle: 'Strojírenská výroba od roku 1993',
      title: 'Precizní obrábění & ocelové konstrukce',
      description: 'Zakázková kusová a malosériová strojírenská výroba s moderním strojním vybavením.',
      cta: 'Nezávazná poptávka',
      cta_secondary: 'Strojový park'
    },
    // Stats
    stats: {
      years: 'let zkušeností',
      employees: 'zaměstnanců',
      area: 'm² výrobní plochy',
      machines: 'Strojů'
    },
    // About
    about: {
      title: 'O firmě',
      subtitle: 'Rodinná firma s tradicí',
      history_title: 'Historie',
      history_text: 'Firma KAISRLÍK, spol. s r.o. byla založena v roce 1993 a navazuje na zámečnickou výrobu založenou Ing. Zdeňkem Kaisrlíkem v roce 1990. Postupně se rozrostla v moderní výrobní společnost s přibližně 50 zaměstnanci a výrobními prostory o rozloze přibližně 3000 m².',
      values_title: 'Naše hodnoty',
      values: {
        quality: 'Kvalita výroby',
        quality_desc: 'Důraz na precizní zpracování každé zakázky',
        precision: 'Technická preciznost',
        precision_desc: 'Moderní CNC stroje a zkušení operátoři',
        partnership: 'Dlouhodobá spolupráce',
        partnership_desc: 'Budujeme vztahy se zákazníky na léta',
        flexibility: 'Flexibilita',
        flexibility_desc: 'Kusová i malosériová zakázková výroba'
      }
    },
    // Services
    services: {
      title: 'Služby',
      subtitle: 'Komplexní strojírenské služby',
      list: {
        steel: { name: 'Ocelové konstrukce', desc: 'Výroba a montáž ocelových konstrukcí podle projektové dokumentace' },
        machines: { name: 'Výroba strojů', desc: 'Zakázková výroba strojů a strojních zařízení' },
        pipes: { name: 'Potrubní systémy', desc: 'Výroba dílů potrubních systémů' },
        cnc: { name: 'CNC obrábění', desc: 'Přesné CNC obrábění kovů na moderních strojích' },
        locksmith: { name: 'Zámečnické práce', desc: 'Kompletní zámečnické služby' },
        welding: { name: 'Svářečské práce', desc: 'Profesionální svařování různých materiálů' },
        cutting: { name: 'Dělení plechů', desc: 'Plazma, autogen, vodní paprsek, řezání na pile' },
        bending: { name: 'Ohýbání plechů', desc: 'Ohýbání a tváření plechů na ohraňovacích lisech' },
        fixtures: { name: 'Manipulační přípravky', desc: 'Výroba manipulačních přípravků' },
        building: { name: 'Stavební zámečnictví', desc: 'Stavební zámečnické konstrukce' },
        halls: { name: 'Montované haly', desc: 'Výroba montovaných konstrukcí a hal' }
      }
    },
    // Machinery
    machinery: {
      title: 'Strojový park',
      subtitle: 'Moderní výrobní technologie',
      categories: {
        machining: 'Obráběcí centra',
        boring: 'Horizontální vyvrtávačky',
        milling: 'Frézky',
        lathe: 'Soustruhy',
        drilling: 'Vrtačky',
        press: 'Ohraňovací lisy',
        rolling: 'Zkružovačky plechů'
      }
    },
    // References
    references: {
      title: 'Reference',
      subtitle: 'Realizované projekty',
      categories: {
        steel: 'Ocelové konstrukce',
        industrial: 'Průmyslové díly',
        machine: 'Strojní komponenty',
        technology: 'Technologické celky',
        custom: 'Zakázková výroba'
      },
      description: 'Realizujeme výrobu na základě projektové nebo výrobní dokumentace zákazníka. Nabízíme komplexní strojírenské služby od výroby až po montáž.'
    },
    // Career
    career: {
      title: 'Kariéra',
      subtitle: 'Přidejte se k nám',
      intro: 'Jsme stabilní česká rodinná firma s moderním strojním vybavením. Nabízíme dlouhodobou práci v oboru strojírenství.',
      positions: {
        cnc: { name: 'CNC obráběč', desc: 'Obsluha CNC obráběcích center a vyvrtávaček' },
        welder: { name: 'Svářeč', desc: 'Svařování ocelových konstrukcí metodami MIG/MAG, TIG' },
        locksmith: { name: 'Zámečník', desc: 'Zámečnické práce, montáž ocelových konstrukcí' },
        technologist: { name: 'Technolog výroby', desc: 'Příprava výrobní dokumentace, technologické postupy' }
      },
      benefits: {
        title: 'Co nabízíme',
        list: [
          'Stabilní zaměstnání v rodinné firmě',
          'Moderní strojní vybavení',
          'Příjemný pracovní kolektiv',
          'Možnost profesního růstu'
        ]
      },
      apply: 'Máte zájem? Kontaktujte nás'
    },
    // Contact
    contact: {
      title: 'Kontakt',
      subtitle: 'Spojte se s námi',
      info: {
        address: 'Adresa',
        phone: 'Telefon',
        fax: 'Fax',
        email: 'Email',
        ico: 'IČO',
        dic: 'DIČ'
      },
      map_title: 'Kde nás najdete'
    },
    // Footer
    footer: {
      company: 'Rodinná strojírenská firma založená v roce 1993',
      rights: 'Všechna práva vyhrazena'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      technology: 'Technology',
      machinery: 'Machinery',
      references: 'References',
      career: 'Career',
      contact: 'Contact'
    },
    // Hero Section
    hero: {
      subtitle: 'Engineering production since 1993',
      title: 'Precision machining & steel structures',
      description: 'Custom single-piece and small-batch engineering production according to customer technical documentation. Family company with tradition and modern machinery.',
      cta: 'Request Quote',
      cta_secondary: 'Our Machinery'
    },
    // Stats
    stats: {
      years: 'years of experience',
      employees: 'employees',
      area: 'm² production area',
      machines: 'Machines'
    },
    // About
    about: {
      title: 'About Us',
      subtitle: 'Family company with tradition',
      history_title: 'History',
      history_text: 'KAISRLÍK, spol. s r.o. was founded in 1993, continuing the locksmith production established by Ing. Zdeněk Kaisrlík in 1990. It has gradually grown into a modern manufacturing company with approximately 50 employees and production facilities of approximately 2000 m².',
      values_title: 'Our Values',
      values: {
        quality: 'Production Quality',
        quality_desc: 'Focus on precise processing of every order',
        precision: 'Technical Precision',
        precision_desc: 'Modern CNC machines and experienced operators',
        partnership: 'Long-term Partnership',
        partnership_desc: 'Building customer relationships for years',
        flexibility: 'Flexibility',
        flexibility_desc: 'Single-piece and small-batch custom production'
      }
    },
    // Services
    services: {
      title: 'Services',
      subtitle: 'Complete engineering services',
      list: {
        steel: { name: 'Steel Structures', desc: 'Production and assembly of steel structures according to project documentation' },
        machines: { name: 'Machine Manufacturing', desc: 'Custom production of machines and mechanical equipment' },
        pipes: { name: 'Piping Systems', desc: 'Production of piping system components' },
        cnc: { name: 'CNC Machining', desc: 'Precision CNC metal machining on modern machines' },
        locksmith: { name: 'Locksmith Work', desc: 'Complete locksmith services' },
        welding: { name: 'Welding Services', desc: 'Professional welding of various materials' },
        cutting: { name: 'Sheet Metal Cutting', desc: 'Plasma and oxy-fuel sheet metal cutting' },
        bending: { name: 'Sheet Metal Bending', desc: 'Bending and forming on press brakes' },
        fixtures: { name: 'Handling Fixtures', desc: 'Production of handling fixtures' },
        building: { name: 'Construction Locksmithing', desc: 'Construction locksmith structures' },
        halls: { name: 'Prefab Halls', desc: 'Production of prefabricated structures and halls' }
      }
    },
    // Machinery
    machinery: {
      title: 'Machinery',
      subtitle: 'Modern production technology',
      categories: {
        machining: 'Machining Centers',
        boring: 'Horizontal Boring Mills',
        milling: 'Milling Machines',
        lathe: 'Lathes',
        drilling: 'Drilling Machines',
        press: 'Press Brakes',
        rolling: 'Plate Rolling Machines'
      }
    },
    // References
    references: {
      title: 'References',
      subtitle: 'Completed Projects',
      categories: {
        steel: 'Steel Structures',
        industrial: 'Industrial Parts',
        machine: 'Machine Components',
        technology: 'Technological Units',
        custom: 'Custom Production'
      },
      description: 'We carry out production based on customer project or production documentation. We offer comprehensive engineering services from production to assembly.'
    },
    // Career
    career: {
      title: 'Career',
      subtitle: 'Join Our Team',
      intro: 'We are a stable Czech family company with modern machinery. We offer long-term work in the engineering industry.',
      positions: {
        cnc: { name: 'CNC Operator', desc: 'Operation of CNC machining centers and boring mills' },
        welder: { name: 'Welder', desc: 'Welding of steel structures using MIG/MAG, TIG methods' },
        locksmith: { name: 'Locksmith', desc: 'Locksmith work, assembly of steel structures' },
        technologist: { name: 'Production Technologist', desc: 'Preparation of production documentation, technological procedures' }
      },
      benefits: {
        title: 'What We Offer',
        list: [
          'Stable employment in a family company',
          'Modern machinery',
          'Pleasant working environment',
          'Opportunity for professional growth'
        ]
      },
      apply: 'Interested? Contact us'
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Get in Touch',
      info: {
        address: 'Address',
        phone: 'Phone',
        fax: 'Fax',
        email: 'Email',
        ico: 'Company ID',
        dic: 'VAT ID'
      },
      map_title: 'Find Us'
    },
    // Footer
    footer: {
      company: 'Family engineering company founded in 1993',
      rights: 'All rights reserved'
    }
  },
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      services: 'Leistungen',
      technology: 'Technologie',
      machinery: 'Maschinenpark',
      references: 'Referenzen',
      career: 'Karriere',
      contact: 'Kontakt'
    },
    // Hero Section
    hero: {
      subtitle: 'Maschinenbau seit 1993',
      title: 'Präzisionsbearbeitung & Stahlkonstruktionen',
      description: 'Kundenspezifische Einzel- und Kleinserienfertigung nach technischer Dokumentation des Kunden. Familienunternehmen mit Tradition und modernem Maschinenpark.',
      cta: 'Angebot anfordern',
      cta_secondary: 'Maschinenpark'
    },
    // Stats
    stats: {
      years: 'Jahre Erfahrung',
      employees: 'Mitarbeiter',
      area: 'm² Produktionsfläche',
      machines: 'Maschinen'
    },
    // About
    about: {
      title: 'Über uns',
      subtitle: 'Familienunternehmen mit Tradition',
      history_title: 'Geschichte',
      history_text: 'KAISRLÍK, spol. s r.o. wurde 1993 gegründet und führt die von Ing. Zdeněk Kaisrlík 1990 gegründete Schlosserproduktion fort. Es ist schrittweise zu einem modernen Fertigungsunternehmen mit etwa 50 Mitarbeitern und Produktionsstätten von etwa 2000 m² gewachsen.',
      values_title: 'Unsere Werte',
      values: {
        quality: 'Produktionsqualität',
        quality_desc: 'Fokus auf präzise Bearbeitung jedes Auftrags',
        precision: 'Technische Präzision',
        precision_desc: 'Moderne CNC-Maschinen und erfahrene Bediener',
        partnership: 'Langfristige Partnerschaft',
        partnership_desc: 'Aufbau von Kundenbeziehungen über Jahre',
        flexibility: 'Flexibilität',
        flexibility_desc: 'Einzel- und Kleinserienproduktion nach Maß'
      }
    },
    // Services
    services: {
      title: 'Leistungen',
      subtitle: 'Komplette Maschinenbau-Dienstleistungen',
      list: {
        steel: { name: 'Stahlkonstruktionen', desc: 'Herstellung und Montage von Stahlkonstruktionen nach Projektdokumentation' },
        machines: { name: 'Maschinenbau', desc: 'Kundenspezifische Herstellung von Maschinen und Anlagen' },
        pipes: { name: 'Rohrleitungssysteme', desc: 'Herstellung von Rohrleitungskomponenten' },
        cnc: { name: 'CNC-Bearbeitung', desc: 'Präzise CNC-Metallbearbeitung auf modernen Maschinen' },
        locksmith: { name: 'Schlosserarbeiten', desc: 'Komplette Schlosserdienstleistungen' },
        welding: { name: 'Schweißarbeiten', desc: 'Professionelles Schweißen verschiedener Materialien' },
        cutting: { name: 'Blechschneiden', desc: 'Plasma- und Brennschneiden von Blechen' },
        bending: { name: 'Blechbiegen', desc: 'Biegen und Umformen auf Abkantpressen' },
        fixtures: { name: 'Handhabungsvorrichtungen', desc: 'Herstellung von Handhabungsvorrichtungen' },
        building: { name: 'Bauschlosserei', desc: 'Bauschlosserkonstruktionen' },
        halls: { name: 'Fertigbauhallen', desc: 'Herstellung von Fertigkonstruktionen und Hallen' }
      }
    },
    // Machinery
    machinery: {
      title: 'Maschinenpark',
      subtitle: 'Moderne Fertigungstechnik',
      categories: {
        machining: 'Bearbeitungszentren',
        boring: 'Horizontale Bohrwerke',
        milling: 'Fräsmaschinen',
        lathe: 'Drehmaschinen',
        drilling: 'Bohrmaschinen',
        press: 'Abkantpressen',
        rolling: 'Blechrundbiegemaschinen'
      }
    },
    // References
    references: {
      title: 'Referenzen',
      subtitle: 'Abgeschlossene Projekte',
      categories: {
        steel: 'Stahlkonstruktionen',
        industrial: 'Industrieteile',
        machine: 'Maschinenkomponenten',
        technology: 'Technologische Einheiten',
        custom: 'Kundenspezifische Fertigung'
      },
      description: 'Wir führen die Produktion auf der Grundlage der Projekt- oder Fertigungsdokumentation des Kunden durch. Wir bieten umfassende Maschinenbau-Dienstleistungen von der Fertigung bis zur Montage.'
    },
    // Career
    career: {
      title: 'Karriere',
      subtitle: 'Werden Sie Teil unseres Teams',
      intro: 'Wir sind ein stabiles tschechisches Familienunternehmen mit modernem Maschinenpark. Wir bieten langfristige Arbeit in der Maschinenbauindustrie.',
      positions: {
        cnc: { name: 'CNC-Bediener', desc: 'Bedienung von CNC-Bearbeitungszentren und Bohrwerken' },
        welder: { name: 'Schweißer', desc: 'Schweißen von Stahlkonstruktionen mit MIG/MAG, TIG-Verfahren' },
        locksmith: { name: 'Schlosser', desc: 'Schlosserarbeiten, Montage von Stahlkonstruktionen' },
        technologist: { name: 'Fertigungstechnologe', desc: 'Erstellung von Fertigungsdokumentation, technologische Verfahren' }
      },
      benefits: {
        title: 'Was wir bieten',
        list: [
          'Stabile Beschäftigung in einem Familienunternehmen',
          'Moderner Maschinenpark',
          'Angenehmes Arbeitsumfeld',
          'Möglichkeit zur beruflichen Weiterentwicklung'
        ]
      },
      apply: 'Interessiert? Kontaktieren Sie uns'
    },
    // Contact
    contact: {
      title: 'Kontakt',
      subtitle: 'Nehmen Sie Kontakt auf',
      info: {
        address: 'Adresse',
        phone: 'Telefon',
        fax: 'Fax',
        email: 'E-Mail',
        ico: 'Firmen-ID',
        dic: 'USt-IdNr.'
      },
      map_title: 'So finden Sie uns'
    },
    // Footer
    footer: {
      company: 'Familienunternehmen im Maschinenbau gegründet 1993',
      rights: 'Alle Rechte vorbehalten'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('cs');

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
